const TutorialsSection = () => (
  <section className="section">
    <h2>How to Use SignalFly</h2>
    <p>Tutorials coming soon…</p>
  </section>
);

export default TutorialsSection;
